$(document).ready(function () {

// const updateStickyOffset = () => {
//   const $el = $('.product__column-sticky');
//   if (!$el.length) return;

//   const elementHeight = $el.outerHeight();
//   const viewportHeight = $(window).height();

//   if (elementHeight > viewportHeight) {
//     const diff = elementHeight - viewportHeight;
//     $el.css('top', `-${diff}px`);
//   } else {
//     $el.css('top', '0px');
//   }
// };

// $(window).on('load resize', ()=>{
//   setTimeout(() => {
//     updateStickyOffset();
//   }, 1500);
// });
// $(updateStickyOffset);

  /* ============================
     Confirmation Popup
  ============================ */
  const $login = $("#cwLogin");
  const $confirmationPopup = $("#confirmationPopup");

  // Open function
  function openLogin() {
    $login.addClass("active");
    $("body").addClass("cw-login-open");
  }

  // Open function
  function openConfirmationPupup() {
    $confirmationPopup.addClass("active");
    $("body").addClass("cw-login-open");
  }

  $(".cw-login__close[data-close]").on("click", function () {
    $(this).parents(".cw-login").removeClass("active");
    $("body").removeClass("cw-login-open");
  });

  // open confirmation poupu
  $(".cw-open-confirmation").on("click", function (e) {
    e.preventDefault();
    openConfirmationPupup();
  });



  /* ============================
   HEADER SIDEDRAWER
============================ */
  const $menuBtn = $("#menuBtn");
  const $sideDrawer = $("#sideDrawer");
  const $overlay = $("#overlay");

  // Only initialize if elements exist
  if ($menuBtn.length && $sideDrawer.length && $overlay.length) {
    // Toggle menu
    function toggleMenu() {
      $menuBtn.toggleClass("active");
      $sideDrawer.toggleClass("active");
      $overlay.toggleClass("active");

      if ($sideDrawer.hasClass("active")) {
        $("body").css("overflow", "hidden");
      } else {
        $("body").css("overflow", "");
      }
    }

    // Close menu
    function closeMenu() {
      $menuBtn.removeClass("active");
      $sideDrawer.removeClass("active");
      $overlay.removeClass("active");
      $("body").css("overflow", "");
    }

    // Event listeners
    $menuBtn.on("click", toggleMenu);
    $overlay.on("click", closeMenu);

    // Close menu when clicking a link (skip dropdown toggles)
    $sideDrawer.on("click", ".cw-sidedrawer__link", function () {
      if ($(this).is("[data-drawer-toggle]")) return;
      closeMenu();
    });

    // Close menu on Escape key
    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $sideDrawer.hasClass("active")) {
        closeMenu();
      }
    });

    // ── Layer 1: Shop Products toggle ───────────────────────────────────────
    $sideDrawer.on("click", "[data-drawer-toggle]", function (e) {
      e.preventDefault();
      $(this).closest(".cw-sidedrawer__item--has-dropdown").toggleClass("open");
    });

    // ── Layer 2: Category group toggles ────────────────────────────────────
    $sideDrawer.on("click", "[data-group-toggle]", function (e) {
      e.preventDefault();
      const $group = $(this).closest(".cw-sidedrawer__group");
      const isOpen = $group.hasClass("open");

      // Close all siblings first (one open at a time)
      $group
        .siblings(".cw-sidedrawer__group")
        .removeClass("open")
        .find("[data-group-toggle]")
        .attr("aria-expanded", "false");

      // Toggle clicked group
      $group.toggleClass("open", !isOpen);
      $(this).attr("aria-expanded", String(!isOpen));
    });
  }

  /* ============================
     CATEGORY/PRODUCT SLIDER
  ============================ */
  $(".cw-slider").each(function () {
    const sliderContainer = $(this).find(".cw-slider__inner");
    const prevBtn = $(this).find(".cw-slider__arrow--prev");
    const nextBtn = $(this).find(".cw-slider__arrow--next");

    if (sliderContainer.length > 0) {
      new Swiper(sliderContainer[0], {
        slidesPerView: "auto",
        spaceBetween: 16,
        speed: 800,
        navigation: {
          nextEl: nextBtn[0],
          prevEl: prevBtn[0],
        },
        breakpoints: {
          767: {
            slidesPerView: 2,
          },
          1023: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    }
  });

  // instagram

    $(".insta-cw-slider").each(function () {
    const sliderContainer = $(this).find(".cw-slider__inner");
    const prevBtn = $(this).find(".cw-slider__arrow--prev");
    const nextBtn = $(this).find(".cw-slider__arrow--next");

    if (sliderContainer.length > 0) {
      new Swiper(sliderContainer[0], {
        slidesPerView: "auto",
        spaceBetween: 16,
        speed: 800,
        navigation: {
          nextEl: nextBtn[0],
          prevEl: prevBtn[0],
        },
        breakpoints: {
          767: {
            slidesPerView: 2,
          },
          1023: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
      });
    }
  });

  /* ============================
    hero SLIDER
  ============================ */
  // $(".cw-hero__slider").each(function () {
  //   const sliderContainer = $(this).find(".cw-project-slider__inner");
  //   const prevBtn = $(this).find(".cw-slider__arrow--prev");
  //   const nextBtn = $(this).find(".cw-slider__arrow--next");

  // if ($(".cw-hero__slider").length) {
  //   new Swiper(".cw-hero__slider", {
  //     autoplay: {
  //        delay: 5000,
  //     },
  //     slidesPerView: 1,
  //     speed: 800,
  //     dots: true,
  //     loop: true,

  //     pagination: {
  //       el: ".swiper-pagination",
  //       clickable: true,
  //     },

  //     effect: "fade",
  //     fadeEffect: {
  //       crossFade: true,
  //     },

  //     // breakpoints: {
  //     //   768: {
  //     //     slidesPerView: 2,
  //     //     spaceBetween: 24,
  //     //   },
  //     // },
  //   });
  // }

  // });


  const $slider = $('.cw-hero__slider');

  if ($slider.length > 0) {

    function startZoom(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      // Find image within the active slide using jQuery
      const $img = $(activeSlide).find('.cw-hero__media img');
      if ($img.length === 0) return;

      // Remove existing zoom class
      $img.removeClass('is-zooming');

      // Double requestAnimationFrame to ensure the browser registers the class removal 
      // before adding it back (prevents flickering)
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          $img.addClass('is-zooming');
        });
      });
    }

    // function resetOtherSlides(swiper) {
    //   // Loop through slides that are not active
    //   $(swiper.slides).not('.swiper-slide-active').each(function() {
    //     $(this).find('.cw-hero__media img').removeClass('is-zooming');
    //   });
    // }

    const heroSwiper = new Swiper('.cw-hero__slider', {
      slidesPerView: 1,
      speed: 1000,
      loop: true,
       effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      on: {

        // Handle zoom reset and start on transition end
        slideChangeTransitionEnd: function () {
          startZoom(this);
        },
      },
    });
  }






  /* ============================
     PROJECT SLIDER
  ============================ */
  $(".cw-project-slider").each(function () {
    const sliderContainer = $(this).find(".cw-project-slider__inner");
    const prevBtn = $(this).find(".cw-slider__arrow--prev");
    const nextBtn = $(this).find(".cw-slider__arrow--next");

    if (sliderContainer.length > 0) {
      new Swiper(sliderContainer[0], {
        slidesPerView: "auto",
        spaceBetween: 16,
        speed: 800,
        navigation: {
          nextEl: nextBtn[0],
          prevEl: prevBtn[0],
        },
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
        },
      });
    }
  });

  /* ============================
     CATEGORY SLIDER
  ============================ */
  // $(".cw-category-slider").each(function () {
  //   const sliderContainer = $(this).find(".cw-category__inner");
  //   const prevBtn = $(this).find(".cw-slider__arrow--prev");
  //   const nextBtn = $(this).find(".cw-slider__arrow--next");

  //   if (sliderContainer.length > 0) {
  //     new Swiper(sliderContainer[0], {
  //       slidesPerView: "auto",
  //       spaceBetween: 16,
  //       speed: 800,
  //       loop: true,
  //       navigation: {
  //         nextEl: nextBtn[0],
  //         prevEl: prevBtn[0],
  //       },
  //     });
  //   }
  // });

  /* ============================
     TESTIMONIAL SLIDER
  ============================ */
  if ($(".cw-testimonial__slider").length > 0) {
    new Swiper(".cw-testimonial__slider", {
      loop: true,
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 600,
      navigation: {
        nextEl: ".cw-testimonial__next",
        prevEl: ".cw-testimonial__prev",
      },
    });
  }

//   /* ============================
//      VIDEO MODAL
//   ============================ */
//   const $modal = $("#videoModal");
//   const $iframe = $("#modalIframe");

//   // Only initialize if modal exists
//   if ($modal.length > 0 && $iframe.length > 0) {
//     // Open Modal
//     $(".cw-media__play-btn, .cw-gallery__item__play-btn").on("click", function () {
//     const $modal = $("#videoModal"); // Ensure this is defined
//     const $iframe = $("#modalIframe");
//     let videoUrl = $(this).data("video-url");

//     // Check if the URL already has a '?' to decide between '?' or '&'
//     const separator = videoUrl.includes('?') ? '&' : '?';
//     const autoplayUrl = videoUrl + separator + 'autoplay=1&mute=1&enablejsapi=1';

//     // 1. Show the modal first so the iframe is 'active' in the DOM
//     $modal.css("display", "flex").hide().fadeIn(300);
//     $("body").css("overflow", "hidden");

//     // 2. Set the src AFTER the modal starts appearing
//     $iframe.attr("src", autoplayUrl);
// });

//     // Close Modal Function
//     function closeModal() {
//       $modal.fadeOut(300, function () {
//         $iframe.attr("src", ""); // Stop video
//         $(this).hide();
//         $("body").css("overflow", "auto");
//       });
//     }

//     // Close on button click
//     $(".cw-modal__close").on("click", closeModal);

//     // Close on overlay click
//     $(".cw-modal__overlay").on("click", closeModal);

//     // Close on ESC key
//     $(document).on("keydown", function (e) {
//       if (e.key === "Escape" && $modal.is(":visible")) {
//         closeModal();
//       }
//     });
//   }

  /* ============================
     PRODUCT GALLERY - MAIN SWIPER
  ============================ */
  let cwMain = null;

  // if ($(".cw-product__main").length > 0) {
  //   cwMain = new Swiper(".cw-product__main", {
  //     slidesPerView: 1,
  //     speed: 600,
  //     spaceBetween: 24,
  //     pagination: {
  //       el: ".cw-product__pagination",
  //       clickable: true,
  //     },
  //     mousewheel: true,

  //     // centeredSlides: true,
  //     breakpoints: {
  //       991: {
  //         slidesPerView: "auto",
  //         direction: "vertical",
  //         mousewheel: true,
  //       },
  //     },
  //   });
  // }

  // $(document).on(
  //   "change",
  //   ".product__info-wrapper input, .product__info-wrapper select",
  //   function () {
  //     const variantId = $('[name="id"]').val();
  //     const mediaId = window.cwVariantMediaMap?.[variantId];
  //     let targetIndex = 0; // default to first image

  //     if (mediaId && cwMain) {
  //       $(".cw-product__main .swiper-slide").each(function (i) {
  //         if ($(this).data("media-id") == mediaId) {
  //           targetIndex = i;
  //           return false;
  //         }
  //       });
  //     }

  //     if (cwMain) cwMain.slideTo(targetIndex, 400);
  //   },
  // );

  /* ============================
     SMOOTH SCROLL FOR ANCHOR LINKS
  ============================ */
  $('a[href^="#"]').on("click", function (e) {
    const href = this.getAttribute("href");

    // Ignore bare "#" or empty hash links — they have no target to scroll to
    if (!href || href === "#") return;

    const target = $(href);

    if (target.length) {
      e.preventDefault();
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: target.offset().top - 100,
          },
          800,
        );
    }
  });

  // /* ============================
  //    ACCESSIBILITY ENHANCEMENTS
  // ============================ */
  // // Trap focus in modal when open
  // if ($modal.length > 0) {
  //   const focusableElements =
  //     'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  //   $modal.on("keydown", function (e) {
  //     if (e.key === "Tab" && $(this).is(":visible")) {
  //       const focusable = $(this).find(focusableElements).filter(":visible");
  //       const firstFocusable = focusable.first()[0];
  //       const lastFocusable = focusable.last()[0];

  //       if (e.shiftKey) {
  //         if (document.activeElement === firstFocusable) {
  //           lastFocusable.focus();
  //           e.preventDefault();
  //         }
  //       } else {
  //         if (document.activeElement === lastFocusable) {
  //           firstFocusable.focus();
  //           e.preventDefault();
  //         }
  //       }
  //     }
  //   });
  // }

  /* ============================
     FILTER SIDEDRAWER
  ============================ */
  const $filterBtn = $(".cw-filter__btn");
  const $filterDrawer = $("#filterDrawer");
  const $filterOverlay = $("#filterOverlay");
  const $filterCloseBtn = $("#filterCloseBtn");
  const $applyFiltersBtn = $("#applyFiltersBtn");
  const $clearFiltersBtn = $("#clearFiltersBtn");

  // Only initialize if elements exist
  if (
    $filterBtn.length > 0 &&
    $filterDrawer.length > 0 &&
    $filterOverlay.length > 0
  ) {
    // Open filter drawer
    function openFilterDrawer() {
      $filterDrawer.addClass("active");
      $filterOverlay.addClass("active");
      $("body").css("overflow", "hidden");
    }

    // Close filter drawer
    function closeFilterDrawer() {
      $filterDrawer.removeClass("active");
      $filterOverlay.removeClass("active");
      $("body").css("overflow", "");
    }

    // Event listeners
    $filterBtn.on("click", openFilterDrawer);
    $filterOverlay.on("click", closeFilterDrawer);
    $filterCloseBtn.on("click", closeFilterDrawer);

    // Close on escape key
    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $filterDrawer.hasClass("active")) {
        closeFilterDrawer();
      }
    });

    // Apply filters
    $applyFiltersBtn.on("click", function () {
      // Get selected category
      const selectedCategory = $('input[name="category"]:checked').val();

      // Get selected collection
      const selectedCollection = $('input[name="collection"]:checked').val();

      // Get price range
      const priceValue = $("#priceRange").val() || 0;

      console.log("Applying filters:", {
        category: selectedCategory,
        collection: selectedCollection,
        maxPrice: priceValue,
      });

      closeFilterDrawer();
    });

    // Clear filters
    $clearFiltersBtn.on("click", function () {
      // Reset to first radio in each group
      $('input[name="category"]').first().prop("checked", true);
      $('input[name="collection"]').first().prop("checked", true);

      // Update active classes
      $(".cw-filter-drawer__option").removeClass(
        "cw-filter-drawer__option--active",
      );
      $('input[name="category"]:checked')
        .closest(".cw-filter-drawer__option")
        .addClass("cw-filter-drawer__option--active");
      $('input[name="collection"]:checked')
        .closest(".cw-filter-drawer__option")
        .addClass("cw-filter-drawer__option--active");

      // Reset price range
      const $priceRange = $("#priceRange");
      if ($priceRange.length > 0) {
        $priceRange.val(0);
        updatePriceRangeFill();
      }

      console.log("Filters cleared");
    });
  }

  /* ============================
     RADIO BUTTON TOGGLES
  ============================ */
  $(".cw-filter-drawer__option").on("click", function () {
    const $this = $(this);
    const $radio = $this.find('input[type="radio"]');
    const groupName = $radio.attr("name");

    // Remove active from all in group
    $(`input[name="${groupName}"]`)
      .closest(".cw-filter-drawer__option")
      .removeClass("cw-filter-drawer__option--active");

    // Add active to clicked
    $this.addClass("cw-filter-drawer__option--active");

    // Check the radio
    $radio.prop("checked", true);
  });

  /* ============================
     PRICE RANGE SLIDER (Dual Thumb)
  ============================ */
  const $priceMin = $("#priceRangeMin");
  const $priceMax = $("#priceRangeMax");
  const $rangeFill = $(".cw-filter-drawer__range-fill");
  const $minDisplay = $("#priceMinDisplay");
  const $maxDisplay = $("#priceMaxDisplay");

  function updateDualPriceRange() {
    const min = parseInt($priceMin.val());
    const max = parseInt($priceMax.val());
    const rangeMin = parseInt($priceMin.attr("min"));
    const rangeMax = parseInt($priceMax.attr("max"));

    // Prevent overlap
    if (min > max - 100) {
      $priceMin.val(max - 100);
    }

    if (max < min + 100) {
      $priceMax.val(min + 100);
    }

    // Calculate fill position
    const minPercent =
      ((parseInt($priceMin.val()) - rangeMin) / (rangeMax - rangeMin)) * 100;
    const maxPercent =
      ((parseInt($priceMax.val()) - rangeMin) / (rangeMax - rangeMin)) * 100;
    $rangeFill.css({
      left: minPercent + "%",
      width: maxPercent - minPercent + "%",
    });

    // Update display
    $minDisplay.text(`$${parseInt($priceMin.val()).toLocaleString()}`);
    $maxDisplay.text(`$${parseInt($priceMax.val()).toLocaleString()}`);
  }

  if ($priceMin.length > 0 && $priceMax.length > 0) {
    $priceMin.on("input", updateDualPriceRange);
    $priceMax.on("input", updateDualPriceRange);
    updateDualPriceRange();
  }
});

// ================================ //
// ======== Process Steps ======== //
// ================================ //
$(function () {
  const TRIGGER = 0.7; // tweak 0.0–1.0 to control when each step activates
  const $blocks = $(".cw-split-content__content-block[data-step]");
  const $images = $(".cw-split-content__media-item[data-step]");
  let activeStep = -1;

  function activateStep(step) {
    if (step === activeStep) return;
    activeStep = step;

    // text blocks: only deactivate if going backwards
    $blocks.each(function () {
      const s = +$(this).data("step");
      if (s <= step) {
        $(this).addClass("is-active");
      } else {
        $(this).removeClass("is-active");
      }
    });

    // images
    $images.each(function () {
      const $el = $(this);
      const s = +$el.data("step");

      $el.removeClass("is-active is-visited").removeAttr("data-offset");

      if (s === step) {
        $el.addClass("is-active is-visited");
      } else if (s < step) {
        const offset = step - s;
        $el.addClass("is-visited").attr("data-offset", Math.min(offset, 3));
      }
    });
  }

  function onScroll() {
    const scrollTop = $(window).scrollTop();
    const threshold = scrollTop + $(window).height() * TRIGGER;
    let newStep = 0;

    $blocks.each(function () {
      if ($(this).offset().top <= threshold) {
        newStep = +$(this).data("step");
      }
    });

    // if scrolled back above the very first block, reset to -1 so step 0 re-triggers
    const firstBlockTop = $blocks.first().offset().top;
    if (scrollTop + $(window).height() * TRIGGER < firstBlockTop) {
      newStep = -1;
    }

    activateStep(newStep);
  }

  function onScroll() {
    const scrollTop = $(window).scrollTop();
    const threshold = scrollTop + $(window).height() * TRIGGER;
    let newStep = 0;

    $blocks.each(function () {
      if ($(this).offset().top <= threshold) {
        newStep = +$(this).data("step");
      }
    });

    // if scrolled back above the very first block, reset to -1 so step 0 re-triggers
    const firstBlockTop = $blocks.first().offset().top;
    if (scrollTop + $(window).height() * TRIGGER < firstBlockTop) {
      newStep = -1;
    }

    activateStep(newStep);
  }

  function onScroll() {
    const threshold = $(window).scrollTop() + $(window).height() * TRIGGER;
    let newStep = 0;
    $blocks.each(function () {
      if ($(this).offset().top <= threshold) newStep = +$(this).data("step");
    });
    activateStep(newStep);
  }

  activateStep(0);
  $(window).on("scroll.ps resize.ps", onScroll);
});

// ===============================//
// ======== What we belive =======//
// ===============================//
(function () {
  const DURATION = 5000;
  const TICK = 50;

  const section = document.getElementById("what-we-believe");
  if (!section) return;
  const items = Array.from(
    section.querySelectorAll(".cw-what-we-believe__item"),
  );
  const images = Array.from(
    section.querySelectorAll(".cw-split-content__media img"),
  );

  let currentIndex = 0;
  let elapsed = 0;
  let ticker = null;

  function isMobile() {
    return window.innerWidth <= 767;
  }

  const TRANSITION = 350; // ms — must match CSS transition

  function collapseBody(item) {
    const body = item.querySelector(".cw-what-we-believe__item-body");
    // Pin to real px height so CSS transition animates from actual value
    body.style.maxHeight = body.scrollHeight + "px";
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        body.style.maxHeight = "0px";
      }),
    );
    item.classList.remove("is-active");
    item.setAttribute("aria-expanded", "false");
    const fill = item.querySelector(".cw-what-we-believe__item-progress-fill");
    if (fill) fill.style.width = "0%";
  }

  function expandBody(item, resetFill) {
    const body = item.querySelector(".cw-what-we-believe__item-body");
    body.style.maxHeight = body.scrollHeight + "px";
    item.classList.add("is-active");
    item.setAttribute("aria-expanded", "true");
    if (resetFill) {
      const fill = item.querySelector(
        ".cw-what-we-believe__item-progress-fill",
      );
      if (fill) fill.style.width = "0%";
    }

    // Release max-height after transition so it isn't clipped
    setTimeout(() => {
      if (item.classList.contains("is-active")) body.style.maxHeight = "none";
    }, TRANSITION);
  }

  function activateItem(index, resetFill) {
    items.forEach((item, i) => {
      if (i === index) {
        expandBody(item, resetFill);
      } else if (item.classList.contains("is-active")) {
        collapseBody(item);
      }
    });
    images.forEach((img, i) => img.classList.toggle("is-active", i === index));
  }

  function tickProgress() {
    elapsed += TICK;
    const pct = Math.min((elapsed / DURATION) * 100, 100);
    const fill = items[currentIndex].querySelector(
      ".cw-what-we-believe__item-progress-fill",
    );
    if (fill) fill.style.width = pct + "%";
    if (elapsed >= DURATION) {
      elapsed = 0;
      currentIndex = (currentIndex + 1) % items.length;
      activateItem(currentIndex, true);
    }
  }

  function startTicker() {
    clearTicker();
    ticker = setInterval(tickProgress, TICK);
  }

  function clearTicker() {
    if (ticker) {
      clearInterval(ticker);
      ticker = null;
    }
  }

  function goToItem(index) {
    if (isMobile()) return;
    clearTicker();
    elapsed = 0;
    currentIndex = index;
    activateItem(currentIndex, true);
    startTicker();
  }

  function init() {
    if (isMobile()) {
      clearTicker();
      items.forEach((item) => {
        item.classList.remove("is-active");
        item.setAttribute("aria-expanded", "false");
        const fill = item.querySelector(
          ".cw-what-we-believe__item-progress-fill",
        );
        if (fill) fill.style.width = "0%";
      });
      images.forEach((img) => img.classList.remove("is-active"));
    } else {
      activateItem(currentIndex, true);
      startTicker();
    }
  }

  items.forEach((item, i) => {
    item.addEventListener("click", () => goToItem(i));
    item.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        goToItem(i);
      }
    });
  });

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  });

  init();

})();
